export class AccountTier {
  private name: string;
  private stepperComponent: JSX.Element[];
  private stepperOutlet: JSX.Element;
  constructor(
    name: string,
    stepperComponent: JSX.Element[],
    stepperOutlet: JSX.Element
  ) {
    this.name = name;
    this.stepperComponent = stepperComponent;
    this.stepperOutlet = stepperOutlet;
  }

  get tierName() {
    return this.name;
  }

  get tierStepperComponent() {
    return this.stepperComponent;
  }

  get tierStepperOutlet() {
    return this.stepperOutlet;
  }
}
